import moment from 'moment';
import 'moment/locale/th';

class HostingItem {
    constructor(){
        this.id = ''
        this.link = ''
        this.size = ''
        this.folderName = ''
        this.status = 'กำลังดำเนินการ'
        this.link = ''
        this.files = null
        this.type = ''

        this.filePathsArray = []

        this.createdAt = ''
    }

    static initBySnapshot(docSnapshot){
        const obj = docSnapshot.data();
        const hostingItem = new HostingItem()
        
        var size = 0

        hostingItem.id = docSnapshot.id

        if(obj.size !== undefined) size = obj.size
        else {
            obj.file.forEach(file=>{
                size += file.size
                hostingItem.filePathsArray.push(file.path)
            })
        }
       
        hostingItem.size    = size
        hostingItem.files   = obj.file

        obj.folder_name     !== undefined ? hostingItem.folderName  = obj.folder_name           : hostingItem.folderName = 'ไม่มีชื่อ'
        obj.created_date    !== undefined ? hostingItem.createdAt   = obj.created_date.toDate() : hostingItem.createdAt = ''
        obj.status          !== undefined ? hostingItem.status      = obj.status                : hostingItem.status    = 'กำลังดำเนินการ'
        obj.link            !== undefined ? hostingItem.link        = obj.link                  : hostingItem.link      = ''
        obj.type            !== undefined ? hostingItem.type        = obj.type                  : hostingItem.type      = ''

        return hostingItem
    }

    createdAtString() {
        if ( this.createdAt === null ) return null;
        return moment(this.createdAt).locale('th').format('D MMMM YYYY');
    }

    sizeString(){
        if(this.size/1073741824 > 1){
            return (this.size/1073741824).toFixed(2)+' GB'
        }
        return (this.size/1048576).toFixed(2)+ ' MB'
    }

    createObjectForFirestore(uid){
        let obj = {
            size : this.size,
            deleted_date : new Date(),
            files : this.files,
            folder_name : this.folderName,
            uid : uid
        }
        return obj
    }

}

export default HostingItem


// WEBPACK FOOTER //
// ./src/Models/HostingItem.js